import { Deletable, Factory, I18nString, Modifiable } from '..'
import { applyEntitySchema, objectSchema, optionalTolerant, sourceJson } from '../../_utils/fcdc-v2'
import * as z from 'zod'

const priceCategorySchema = objectSchema({
  id: optionalTolerant(z.string()),
  names: optionalTolerant(z.array(z.unknown())),
  note: optionalTolerant(z.string()),
  created: optionalTolerant(z.union([z.string(), z.number()])),
  modified: optionalTolerant(z.union([z.string(), z.number()])),
  deleted: optionalTolerant(z.boolean()),
})

export class PriceCategory implements Deletable, Modifiable {
  id: string
  names: I18nString[]
  note?: string
  created: Date
  modified: Date
  deleted: boolean

  constructor(json: any) {
    const source = sourceJson(json) as any
    const names = Array.isArray(source.names) ? source.names.map((name: unknown) => sourceJson(name)) : undefined
    const plain: Record<string, unknown> = { ...source }
    if (Array.isArray(names)) {
      plain['names'] = names
    }

    this.id = source.id
    this.names = Array.isArray(names) ? names.map(name => new I18nString(name)) : []
    this.note = source.note
    this.created = new Date(source.created)
    this.modified = new Date(source.modified)
    this.deleted = source.deleted ? Boolean(source.deleted) : false
    applyEntitySchema(this, priceCategorySchema, plain, { names: [] })
  }

  static getFactory(): Factory<PriceCategory> {
    return new (class implements Factory<PriceCategory> {
      make(json: any): PriceCategory {
        return new PriceCategory(json)
      }

      getTableName(): string {
        return 'locker_price_categories'
      }
    })()
  }

  static getUrl(priceCategoryId?: string): string {
    return `/locker_price_categories` + (priceCategoryId ? '/' + priceCategoryId : '')
  }
}
